import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export function NotFound() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/', { replace: true });
  }, [navigate]);

  return null;
}

export default NotFound;
